const SUBSCRIBED_KEY = "email_opt_in_subscribed";

export const readEmailOptInSubscribed = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  try {
    return window.localStorage.getItem(SUBSCRIBED_KEY) === "1";
  } catch {
    return false;
  }
};

export const writeEmailOptInSubscribed = (): void => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(SUBSCRIBED_KEY, "1");
  } catch {
    // localStorage unavailable — fall through silently
  }
};
